import axios from "axios"
export default {
	async getRecentBlocks() {
		let value = await axios.get("http://localhost:8080/api/blockshttp://localhost:8080/api/blocks")
		if (value?.error?.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		let data = value.data
		return data
	}
}